import Label from "components/Label/Label";
import React, { FC, useEffect, useState } from "react";
import Avatar from "shared/Avatar/Avatar";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
// import Textarea from "shared/Textarea/Textarea";
import CommonLayout from "./CommonLayout";
import { Helmet } from "react-helmet";
import axios from "axios";
import { getCookie, removeCookie } from "utils/cookies";
import { UserType } from "data/types";
import Badge from "shared/Badge/Badge";
import { debounce } from "ts-debounce";

if (!getCookie("access-token") && window.location.href.includes("/account")) {
  window.location.href = "/";
}

export interface AccountPageProps {
  className?: string;
}

const AccountPage: FC<AccountPageProps> = ({ className = "" }) => {
  const [deleteButn, setDeleteButn] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState<UserType>();
  const [typeCd, setTypeCd] = useState({
    typeCd: "",
  });
  const [nickNm, setNickNm] = useState({
    nickNm: "",
  });
  const [isValidButn, setIsValidButn] = useState(false);
  const [checkNickStatusCode, setCheckNickStatusCode] = useState();
  const [userProfileImgType, setUserProfileImgType] = useState();
  const [userProfileRequstBase64, setUserProfileRequestBase64] = useState("");
  const [profileUrl, setProfileUrl] = useState("");
  const [currentHover, setCurrentHover] = useState(false);
  const accessToken: string = getCookie("access-token");
  const refreshToken: string = getCookie("refresh-token");
  const userId = Number(getCookie("user-id"));

  useEffect(() => {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/Users/GetUserInfo`,
        {
          userId: userId,
        },
        {
          headers: {
            Authorization: accessToken,
            subAuthorization: refreshToken,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      )
      .then(response => {
        setUser(response.data.data);
      })
      .catch(error => console.log(error));
    if (user?.email.includes("google.com")) {
      setTypeCd({
        typeCd: "1",
      });
    } else if (user?.email.includes("apple.com")) {
      setTypeCd({
        typeCd: "2",
      });
    } else {
      setTypeCd({
        typeCd: "0",
      });
    }
    if (userProfileRequstBase64.length > 0) {
      axios
        .post(`${process.env.REACT_APP_AWS_S3}/uploads`, {
          mime: userProfileImgType,
          data: userProfileRequstBase64,
        })
        .then(response => {
          setProfileUrl(response.data.Location);
        })
        .catch(error => console.log(error));
    }

    if (profileUrl && userProfileRequstBase64) {
      setIsValidButn(true);
    } else {
      setIsValidButn(false);
    }
  }, [
    profileUrl,
    userProfileRequstBase64,
    currentHover,
    userId,
    accessToken,
    refreshToken,
    user?.email,
    userProfileImgType,
  ]);

  function InputNickName(e: any) {
    setNickNm({
      nickNm: e.target.value,
    });
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/Users/CheckNick`, {
        lngcd: window.localStorage.getItem("locale"),
        nicknm: nickNm.nickNm,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      })
      .then(response => {
        if (response.data.status === 200) {
          setIsValidButn(true);
        } else {
          setIsValidButn(false);
        }
        setCheckNickStatusCode(response.data.status);
      })
      .catch(error => console.log(error));
  }

  function UpdateProfileImg(event: any) {
    let file = event.target.files[0];
    setUserProfileImgType(file.type);
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      let result = String(reader.result);
      const base64 = result.slice(result.indexOf("/9j/"));
      setUserProfileRequestBase64(base64);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  }

  function UpdateInfo() {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/Users/SetUserProFileUrl`,
        {
          profileUrl: profileUrl,
          userId: Number(getCookie("user-id")),
          lngCd: window.localStorage.getItem("locale"),
        },
        {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      )
      .then(response => {
        if (response.data.status === 200) {
        }
      })
      .catch(error => console.log(error));
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/Users/SetUserInfoUp`,
        {
          userId: Number(getCookie("user-id")),
          typeCd: typeCd.typeCd,
          lngCd: window.localStorage.getItem("locale"),
          firstNm: user?.firstNm,
          lastNm: user?.lastNm,
          nickNm: !nickNm.nickNm ? user?.nickNm : nickNm.nickNm,
          email: user?.email,
          terms: true,
          privacy: true,
        },
        {
          headers: {
            Authorization: String(accessToken),
            subAuthorization: String(refreshToken),
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      )
      .then(response => {
        if (response.data.status === 200) {
          alert("Update successed");
          setIsValidButn(false);
          setUserProfileRequestBase64("");
        }
      })
      .catch(error => console.log(error));
  }

  function handleDeleteButn(e: any) {
    if (e.target.value === user?.email) {
      setDeleteButn(false);
    } else {
      setDeleteButn(true);
    }
  }

  function accountDelete() {
    axios
      .post(
        `${process.env.REACT_APP_BASE_URL}/Users/SetUserInfoUnregister`,
        {
          userId: Number(getCookie("user-id")),
        },
        {
          headers: {
            Authorization: accessToken,
            subAuthorization: refreshToken,
            "Content-type": "application/json; charset=UTF-8",
          },
        }
      )
      .then(response => {
        if (response.status == 200) {
          window.sessionStorage.clear();
          removeCookie("access-token");
          removeCookie("refresh-token");
          removeCookie("user-id");
          removeCookie("uid");
        } else {
          alert("Service error");
        }
      })
      .catch(error => console.log(error));
  }

  return (
    <>
      {user ? (
        <div className={`nc-AccountPage ${className}`} data-nc-id="AccountPage">
          <Helmet>
            <title>Account || Booking React Template</title>
          </Helmet>
          <CommonLayout>
            <div className="space-y-6 sm:space-y-8">
              {/* HEADING */}
              <h2 className="text-3xl font-semibold">Account infomation</h2>
              <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
              <div className="flex flex-col md:flex-row">
                <div className="flex-shrink-0 flex items-start">
                  <div
                    className="relative rounded-full overflow-hidden flex"
                    onMouseEnter={() => {
                      setCurrentHover(true);
                    }}
                    onMouseLeave={() => {
                      setCurrentHover(false);
                    }}
                  >
                    <Avatar
                      imgUrl={!profileUrl ? user?.url : profileUrl}
                      sizeClass="w-32 h-32"
                    />
                    {currentHover ? (
                      <div className="absolute inset-0 bg-black bg-opacity-60 flex flex-col items-center justify-center text-neutral-50 cursor-pointer">
                        <svg
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.5 5H7.5C6.83696 5 6.20107 5.26339 5.73223 5.73223C5.26339 6.20107 5 6.83696 5 7.5V20M5 20V22.5C5 23.163 5.26339 23.7989 5.73223 24.2678C6.20107 24.7366 6.83696 25 7.5 25H22.5C23.163 25 23.7989 24.7366 24.2678 24.2678C24.7366 23.7989 25 23.163 25 22.5V17.5M5 20L10.7325 14.2675C11.2013 13.7988 11.8371 13.5355 12.5 13.5355C13.1629 13.5355 13.7987 13.7988 14.2675 14.2675L17.5 17.5M25 12.5V17.5M25 17.5L23.0175 15.5175C22.5487 15.0488 21.9129 14.7855 21.25 14.7855C20.5871 14.7855 19.9513 15.0488 19.4825 15.5175L17.5 17.5M17.5 17.5L20 20M22.5 5H27.5M25 2.5V7.5M17.5 10H17.5125"
                            stroke="currentColor"
                            strokeWidth={1.5}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="mt-1 text-xs">Change Image</span>
                      </div>
                    ) : null}
                    <input
                      onChange={file => UpdateProfileImg(file)}
                      type="file"
                      className="absolute inset-0 opacity-0 cursor-pointer"
                    />
                  </div>
                </div>
                <div className="flex-grow mt-10 md:mt-0 md:pl-16 max-w-3xl space-y-6">
                  <div>
                    <Label>Name</Label>
                    <Input
                      className="mt-1.5 bg-[#e1e1e1]"
                      value={`${user?.lastNm} ${user?.firstNm}`}
                      disabled={true}
                    />
                  </div>
                  {/* ---- */}
                  {/* <div>
                <Label>Gender</Label>
                <Select className="mt-1.5">
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </Select>
              </div> */}
                  {/* ---- */}
                  <div>
                    <Label>Nickname</Label>
                    {checkNickStatusCode === 400 ? (
                      <Badge color="red" name="exists" />
                    ) : null}
                    <Input
                      className="mt-1.5"
                      defaultValue={user?.nickNm}
                      onChange={debounce(InputNickName, 1000)}
                    />
                  </div>
                  {/* ---- */}
                  <div>
                    <Label>Email</Label>
                    <Input
                      className="mt-1.5 bg-[#e1e1e1]"
                      defaultValue={user?.email}
                      disabled={true}
                    />
                  </div>
                  {/* ---- */}
                  {/* <div className="max-w-lg">
                <Label>Date of birth</Label>
                <Input
                  className="mt-1.5"
                  type="date"
                  defaultValue="1990-07-22"
                />
              </div> */}
                  {/* ---- */}
                  {/* <div>
                <Label>Addess</Label>
                <Input className="mt-1.5" defaultValue="" />
              </div> */}
                  {/* ---- */}
                  {/* <div>
                <Label>Phone number</Label>
                <Input className="mt-1.5" defaultValue="" />
              </div> */}
                  {/* ---- */}
                  {/* <div>
                <Label>About you</Label>
                <Textarea className="mt-1.5" defaultValue="..." />
              </div> */}
                  <div className="flex items-center justify-between">
                    <div className="pt-2">
                      <ButtonPrimary
                        onClick={UpdateInfo}
                        disabled={!isValidButn ? true : false}
                      >
                        Update info
                      </ButtonPrimary>
                    </div>
                    <div
                      onClick={() => {
                        if (isModalOpen) {
                          setIsModalOpen(false);
                        } else {
                          setIsModalOpen(true);
                        }
                      }}
                    >
                      <span className="text-red-400 cursor-pointer">
                        Delete account
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </CommonLayout>
        </div>
      ) : null}
      {isModalOpen ? (
        <div className="fixed top-[35%] left-[35%] bg-white shadow-2xl w-[400px] h-[250px] rounded-[5px] pt-5 pb-5">
          <div className="flex flex-col justify-between items-center w-full h-full">
            <span className="w-[280px]">
              Please enter your <b>Email</b>, <br />
              If you delete account, you will not be able to use the NEME
              service.
            </span>
            <div className="border border-neutral-400">
              <input
                onChange={handleDeleteButn}
                className="text-center w-[280px]"
                placeholder="example@example.com"
              />
            </div>
            <div className="flex space-x-[100px]">
              <button
                className={`w-[100px] h-[30px] text-red-400 border rounded-[20px] bg-${
                  deleteButn ? "gray-100" : null
                }`}
                onClick={accountDelete}
                disabled={deleteButn}
              >
                Delete
              </button>
              <button
                className="w-[100px] h-[30px] border rounded-[20px]"
                onClick={() => {
                  if (isModalOpen) {
                    setIsModalOpen(false);
                  } else {
                    setIsModalOpen(true);
                  }
                }}
              >
                Cancle
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AccountPage;
